import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';
import { alpha, useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { FC } from 'react';

import { PageContainer } from '#/components/page-container';

export const BillingOrderDetailPreloader: FC = () => {
  const theme = useTheme();

  return (
    <PageContainer>
      <Container maxWidth="xl" sx={{ py: 4 }}>
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Skeleton variant="circular" width={48} height={48} />
            <Box>
              <Skeleton variant="text" width={180} height={36} />
              <Skeleton variant="text" width={140} height={20} sx={{ mt: 0.5 }} />
            </Box>
          </Box>
          <Skeleton variant="rounded" width={88} height={28} />
        </Box>

        {/* Table */}
        <TableContainer sx={{ borderRadius: 2, border: `1px solid ${theme.palette.divider}`, mb: 3 }}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: alpha(theme.palette.grey[500], 0.04) }}>
                <TableCell sx={{ fontWeight: 700 }}>Product</TableCell>
                <TableCell sx={{ fontWeight: 700 }} align="center">
                  Qty
                </TableCell>
                <TableCell sx={{ fontWeight: 700 }} align="right">
                  Unit Price
                </TableCell>
                <TableCell sx={{ fontWeight: 700 }} align="right">
                  Discount
                </TableCell>
                <TableCell sx={{ fontWeight: 700 }} align="right">
                  Total
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.from({ length: 3 }).map((_, i) => (
                // oxlint-disable-next-line react/no-array-index-key
                <TableRow key={i}>
                  <TableCell>
                    <Skeleton variant="text" width={160} />
                  </TableCell>
                  <TableCell align="center">
                    <Skeleton variant="text" width={24} sx={{ mx: 'auto' }} />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="text" width={64} sx={{ ml: 'auto' }} />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="text" width={24} sx={{ ml: 'auto' }} />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="text" width={64} sx={{ ml: 'auto' }} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Totals */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Box
            sx={{
              width: { xs: '100%', sm: 320 },
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: 2,
              overflow: 'hidden',
            }}
          >
            {Array.from({ length: 3 }).map((_, i) => (
              // oxlint-disable-next-line react/no-array-index-key
              <Box key={i} sx={{ px: 3, py: 2, display: 'flex', justifyContent: 'space-between' }}>
                <Skeleton variant="text" width={60} />
                <Skeleton variant="text" width={72} />
              </Box>
            ))}
            <Divider />
            <Box
              sx={{
                px: 3,
                py: 2,
                display: 'flex',
                justifyContent: 'space-between',
                bgcolor: alpha(theme.palette.grey[500], 0.04),
              }}
            >
              <Skeleton variant="text" width={40} />
              <Skeleton variant="text" width={80} />
            </Box>
          </Box>
        </Box>
      </Container>
    </PageContainer>
  );
};
